import { render, staticRenderFns } from "./CreditcardForm.vue?vue&type=template&id=950e1ccc&"
import script from "./CreditcardForm.vue?vue&type=script&lang=ts&"
export * from "./CreditcardForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports